module.exports = __webpack_public_path__ + "static/media/DBHeaventNow-BoldIt.e1677c34.woff2";